<template>
  <v-card flat>
    <v-card-text>
      <div>
        <v-radio-group
          aria-labelledby="exportType"
          class="ml-4"
          v-model="pickedExportType"
        >
          <template v-slot:label>
            <div class="subtitle-1">
              Velg hvilken type data som skal eksporteres.
            </div>
          </template>
          <v-radio
            label="Eksporter metadata: Velg dette alternativet for å eksportere tidsserier slik de vises i tabellen(e) i applikasjonen. Den eksporterte excel filen vil inneholde de kolonnene som er aktivert i tabellen(e)."
            value="withoutTimeValues"
          ></v-radio>
          <v-radio
            label="Eksporter døgnverdier: Velg dette alternativet for å eksportere døgnverdiene for en angitt tidsperiode. Bruk menyen under for å spesifisere tidsrommet for døgnverdiene som skal være med i eksporten."
            value="withTimeValues"
          ></v-radio>
        </v-radio-group>
        <div class="ml-4" v-show="pickedExportType === 'withTimeValues'">
          <p
            class="text-body-1 ml-4 mr-4 pl-4 red--text"
            v-show="timeSeriesNotAvailableForExport.length > 0"
          >
            Merknad: Seriekart støtter ikke nedlasting av tidsserier der det
            finnes målinger på flere dyp/høyder på ett sted, i NVE kalt
            «vertikaldata». Dette gjelder i hovedsak markfuktighet og noen
            serier for vanntemperatur. Slike tidsseriene vil derfor utelates fra
            nedlastingen. Antall tidsserier som utelates:
            {{ timeSeriesNotAvailableForExport.length }} av
            {{ timeseriesCount }}.
          </p>
          <p class="text-body-1 ml-4 pl-4">
            Velg periode for døgnverdiene som skal hentes ut:
          </p>

          <v-row class="pa-4 ml-4 ma-4">
            <v-text-field
              label="Fra dato"
              type="date"
              v-model="fromDate"
            ></v-text-field>
            <v-text-field
              class="ml-4"
              label="Til dato"
              type="date"
              v-model="toDate"
            ></v-text-field>
          </v-row>
        </div>
      </div>
    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn v-show="showPreviousButton" depressed @click="cancel">
        Forrige
      </v-btn>

      <v-btn
        depressed
        :disabled="
          pickedExportType === 'withTimeValues' &&
            timeseriesCount === timeSeriesNotAvailableForExport.length
        "
        @click="emitStepCompleted"
      >
        Start eksport
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ExportDataStep2",
  data: () => {
    return {
      fromDate: new Date(new Date().setMonth(new Date().getMonth() - 2))
        .toISOString()
        .substr(0, 10),
      toDate: new Date().toISOString().substr(0, 10),
      pickedExportType: "withoutTimeValues",
    };
  },
  props: {
    initFromDate: String,
    initToDate: String,
    timeSeriesNotAvailableForExport: Array,
    timeseriesCount: Number,
    showPreviousButton: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState(["chartDateRange"]),
  },
  watch: {
    chartDateRange: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.dateRange = newVal;
        var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
        this.fromDate = new Date(newVal.start.getTime() - tzoffset)
          .toISOString()
          .substring(0, 10);
        this.toDate = new Date(newVal.end.getTime() - tzoffset)
          .toISOString()
          .substring(0, 10);
      }
    },
  },
  methods: {
    cancel: function() {
      this.$emit("cancel");
    },
    emitStepCompleted() {
      this.$emit("step-completed", {
        pickedExportType: this.pickedExportType,
        fromDate: this.fromDate,
        toDate: this.toDate,
      });
    },
  },
  mounted: function() {
    this.fromDate = this.initFromDate;
    this.toDate = this.initToDate;
  },
};
</script>
